import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { SuperAdminDowngradeResponse, SuperAdminUser } from 'src/types/shared/SuperAdminUser';

export const revokeSuperAdminMfaRequest = createAction('revokeSuperAdminMfaRequest');
export const revokeSuperAdminMfaSuccess = createAction<SuperAdminUser>(
    'revokeSuperAdminMfaSuccess',
);
export const revokeSuperAdminMfaFailure = createAction('revokeSuperAdminMfaFailure');

export const revokeSuperAdminMfa =
    (id: number) =>
    async (dispatch: AppDispatch): Promise<void> => {
        dispatch(revokeSuperAdminMfaRequest());
        try {
            const { data }: UpdateAdminResponse = await api.patch(
                `admin/superadmins/${id}/revoke-mfa`,
                null,
            );

            dispatch(revokeSuperAdminMfaSuccess(data.user));
        } catch (e) {
            handleApiErrors(dispatch, revokeSuperAdminMfaFailure, e);
        }
    };

interface UpdateAdminResponse {
    data: SuperAdminDowngradeResponse;
}
